import CreateClientSchema from '@assets/schema/client/create.json';
import { Button } from '@common/Button/Button';
import { Form } from '@common/Form/Form';
import { FormControl } from '@common/Form/FormControl';
import { SchemaObject, useJsonSchema } from '@common/Form/hooks/useJsonSchema';
import { Heading } from '@common/Typography/Heading';
import { useApi } from '@hooks/useApi';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { CommuneField } from '@screens/Clients/common/CommuneField';
import { VoivodeshipField } from '@screens/Clients/common/VoivodeshipField';
import { createClient } from '@services/api/client';
import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

type AddClientModalFormProps = {
  onSuccess: () => void;
};

export const AddClientModalForm: React.FC<AddClientModalFormProps> = ({ onSuccess }) => {
  const { t } = useTranslation();
  const { controls, schema, onErrorEvent } = useJsonSchema({
    schema: CreateClientSchema as unknown as SchemaObject,
  });

  const { call, isLoading } = useApi({
    method: createClient,
    onSuccess: ({ onSuccessNotification }) => {
      onSuccessNotification(t(`Client has been created`));
      onSuccess();
    },
    onError: onErrorEvent,
  });

  return (
    <FormProvider {...controls}>
      <form
        onSubmit={controls.handleSubmit(call)}
        noValidate>
        <Form schema={schema}>
          <Grid
            container
            spacing={2}>
            <Grid
              item
              md={12}>
              <Heading
                size={6}
                gutterBottom={false}>
                {t('Contact data')}
              </Heading>
            </Grid>
            <Grid
              item
              md={6}>
              <FormControl path="firstName" />
            </Grid>
            <Grid
              item
              md={6}>
              <FormControl path="lastName" />
            </Grid>
            <Grid
              item
              md={12}>
              <Heading
                size={6}
                gutterBottom={false}>
                {t('Address')}
              </Heading>
            </Grid>
            <Grid
              item
              xs={12}>
              <FormControl
                path="county"
                control={VoivodeshipField}
              />
            </Grid>
            <Grid
              item
              xs={12}>
              <FormControl
                path="commune"
                control={CommuneField}
              />
            </Grid>
            <Grid
              item
              xs={6}>
              <FormControl path="street" />
            </Grid>
            <Grid
              item
              xs={6}>
              <FormControl path="house" />
            </Grid>
          </Grid>
        </Form>
        <Box mt={5}>
          <Button
            fluent
            loading={isLoading}
            type="submit"
            disabled={!controls.formState.isValid}
            color="primary">
            {t('Save')}
          </Button>
        </Box>
      </form>
    </FormProvider>
  );
};
